import { LoadingModule } from "@/components/modules/loading";
import { useEffect, useState } from "react";

export const Module404 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, []);

  return isLoading ? (
    <LoadingModule />
  ) : (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-6 text-6xl font-bold">404</h1>
        <div>
          <p>Page is not found!</p>
        </div>
      </div>
    </div>
  );
};
